// 提携：FareRuleSliderComponentをres spaのBlockSliderComponentに置き換える
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaticMsgModule } from '@lib/pipes';
import { FareRuleSliderComponent } from './fare-rule-slider.component';

@NgModule({
  declarations: [FareRuleSliderComponent],
  imports: [CommonModule, StaticMsgModule],
  exports: [FareRuleSliderComponent],
})
export class FareRuleSliderModule {}
